import { Filters } from "./filters";
import { Summary } from "./summary";
import { Columns } from "./columns";
import { BulkActions } from "./bulk-actions";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const FinanceCreditMemosReportConfig: ReportConfigBase = {
  type: EReportTypes.FinanceCreditMemos,
  endpoint: "credit-memo",
  filtersBase: Filters,
  summaryBase: Summary,
  columnsBase: Columns,
  withSelection: true,
  intro: {
    description:
      "Credit Memos",
    // TODO: Need a help article once this is ready
    url: "https://help.commonsku.com/knowledge/",
  },
  bulkActions: BulkActions,
};

export default FinanceCreditMemosReportConfig;
